<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f021-01.jpg" width="80%"/></p>
<p class="caption"><em class="italic">One of the two statues to be found at Armentières depicting the</em> Mademoiselle from Armentières, <em class="italic">a reminder of this popular song which men of the BEF made famous. This one is outside the Central Hospital</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 33_fm041.vue?5b11252a